import { ReactElement, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';

import { calculateInspectionScoreFromForm, formatInspectionScorePercent } from 'store/inspection/utils/inspectionScore';
import { useInputForm } from 'components/dataCreationForms/withInputForm';
import { useInspection } from 'store/inspection';

interface ScoreDisplayProps {
  score: number | null;
}

function ScoreDisplay({ score }: ScoreDisplayProps): ReactElement {
  const displayValue = formatInspectionScorePercent(score) ?? '—';

  return (
    <Box>
      <Typography
        variant="caption"
        component="div"
        sx={{ color: 'text.secondary', mb: 0.5 }}
      >
        <FormattedMessage id={InspectionTranslationKeys.formLabelScore} />
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          color: score !== null ? 'text.primary' : 'text.disabled',
        }}
      >
        {displayValue}
      </Typography>
    </Box>
  );
}

interface InspectionScoreProps {
  scoreValue: number | null;
}

export function InspectionScore({
  scoreValue,
}: InspectionScoreProps): ReactElement {
  return <ScoreDisplay score={scoreValue} />;
}

export function InspectionScoreLive(): ReactElement {
  const { values } = useInputForm();
  const { inspectionModel } = useInspection();

  const calculatedScore = useMemo(() => {
    return calculateInspectionScoreFromForm(values, inspectionModel?.protocol);
  }, [inspectionModel?.protocol, values]);

  return <ScoreDisplay score={calculatedScore} />;
}


